<template>
    <div class="bottom" :class="{'selectt': infoReseauxLc.select}">
      <div class="container_img_info">
        <img :src="url" class="imageBg" alt="">
        <div class="dot_select" @click="contolSelect()"
          :class="{'dot_select1': infoReseauxLc.select}">
          <div class="dot_selected" v-if="infoReseauxLc.select"></div>
        </div>
        <div @click="show = true" class="level is-mobile bgBlur">
          <div class="has-text-white">
            <div
              v-if="infoReseauxLc.extensionOpportunite.duree"
              class="media">
              <b-icon
                icon="timer"
                class="media-left margin_small">
              </b-icon>
              <div class="media-content is-size-7">
                <label>Durée :</label><br>
                <label class="has-text-weight-bold">
                  {{infoReseauxLc.extensionOpportunite.duree}}
                </label>
              </div>
            </div>
          </div>
          <div
            class="level-right"
            v-if="getTarif">
            <h3 class="has-text-weight-bold has-text-white goToLeft">
              {{tarif(getTarif)}} HT
            </h3>
          </div>
        </div>
      </div>
      <div @click="show = true" class="has-background-white infoBorder">
        <div class="level is-marginless">
          <div class="topViolet leftViolet bottomVert">
            <p class="is-size-7">
              <label class="has-text-default">Nom du réseau</label><br>
              <strong class="p_size12 has-text-link">
                {{infoReseauxLc.libelle}}
              </strong>
            </p>
          </div>
        </div>
        <div @click="show = true" class="column leftViolet rightViolet">
          <div class="columns is-multiline is-mobile color-icon">
            <div class="column bottomVert is-6 is-paddingless">
              <div
                v-if="infoReseauxLc.extensionOpportunite.duree"
                class="media">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default"> Durée </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxLc.extensionOpportunite.duree}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="city"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Ville </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxLc.ville}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Format </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxLc.format}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6"
              v-if="infoReseauxLc.nbFaces">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Nombre de faces </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxLc.nbFaces}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div v-if="infoReseauxLc.extensionOpportunite.date"
                  class="media">
                <b-icon
                  icon="calendar-check"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Disponible le : </label><br>
                  <p>{{infoReseauxLc.extensionOpportunite.date}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-12"
              v-if="infoReseauxLc.extensionOpportunite.commentaire">
              <div class="media">
                <div class="media-content">
                    <label class="has-text-weight-bold has-text-link p_size14">
                      Commentaire : </label><br>
                    <p class="p_size12 has-text-default has-text-link">
                      {{infoReseauxLc.extensionOpportunite.commentaire}}
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a>
          <p class="p_size14 has-text-centered has-text-white color-plus-info">
            Plus d'informations
          </p>
        </a>
      </div>
      <app-detail-reseaux-lc-complet-diapo
          :detailResauxComplet="infoReseauxLc"
          v-if="show"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto } from '@/services/opportunite/formatTab';
import detailReseauxLcCompletDiapo from './detailReseauxLcCompletDiapo';

export default {
  name: 'infoReseauxLc',
  props: ['infoReseauxLc'],
  components: {
    appDetailReseauxLcCompletDiapo: detailReseauxLcCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxLc.urlPhoto);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      let tarifBrut = 0;
      if (this.infoReseauxLc.extensionOpportunite.tarifDePose) {
        tarifDePose = this.infoReseauxLc.extensionOpportunite.tarifDePose;
      }
      if (this.infoReseauxLc.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxLc.extensionOpportunite.taxeMunicipale;
      }
      if (this.infoReseauxLc.extensionOpportunite.fraisTechnique) {
        fraisTechnique = this.infoReseauxLc.extensionOpportunite.fraisTechnique;
      }
      if (this.infoReseauxLc.extensionOpportunite.tarifBrut) {
        tarifBrut = this.infoReseauxLc.extensionOpportunite.tarifBrut;
      }
      if (this.infoReseauxLc.extensionOpportunite.tarifNet) {
        tarifNet = this.infoReseauxLc.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return tarifBrut
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxLc.select = !this.infoReseauxLc.select;
      if (this.infoReseauxLc.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxLc/infoReseauxLc.vue